import React, { useRef, useCallback } from 'react';
import './style.scss';
function getNodeToFocus() {
    const modules = document.querySelectorAll('.module');
    for (let i = 0; i < modules.length; i++) {
        if (modules[i].querySelector('nav'))
            continue;
        const firstFocusableNode = getFirstFocusableNode(modules[i]);
        if (firstFocusableNode)
            return firstFocusableNode;
    }
    return null;
}
function getFirstFocusableNode(node) {
    const focusableNodes = node.querySelectorAll('a, button, iframe, [tabIndex="0"]');
    return Array.from(focusableNodes).find((n) => !n.classList.contains('hide') && n.tabIndex > -1) || null;
}
const NavFocusSkipper = () => {
    const firstMainContentNode = useRef(null);
    const skipToMainContent = useCallback(() => {
        var _a;
        if (!firstMainContentNode.current) {
            firstMainContentNode.current = getNodeToFocus();
        }
        try {
            (_a = firstMainContentNode.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        catch (e) {
            console.error('No actionable elements in main content');
        }
    }, []);
    return (React.createElement("a", { href: "#main", onClick: skipToMainContent, style: {
            position: 'fixed',
            opacity: 0,
            top: '-40px',
            left: '10px',
            zIndex: 999,
            borderRadius: '5px',
            padding: '10px',
            background: '#3c763d',
            color: 'white',
            textDecoration: 'underline',
            transition: 'top 0.3s, opacity 0.3s',
        }, onFocus: (e) => {
            e.currentTarget.style.top = '10px';
            e.currentTarget.style.opacity = '1';
        }, onBlur: (e) => {
            e.currentTarget.style.top = '-40px';
            e.currentTarget.style.opacity = '0';
        } }, "Skip to main content"));
};
export default NavFocusSkipper;
